import { cva, type VariantProps } from "class-variance-authority"
import { Button, ButtonSuffix } from "~/react/ui/button"
import { Icon } from "~/react/ui/icon"
import { CostCalculator } from "~/helpers/costCalculator"
import { CurrencyHelper } from "~/helpers/currency_helper"
import { useVerifyEmail } from "~/react/hooks/useVerifyEmail"

const iconVariants = cva("verification-status-icon", {
  variants: {
    status: {
      valid: "fas fa-shield-check verification-status-icon--valid",
      accept_all: "fas fa-shield-halved verification-status-icon--accept-all",
      webmail: "fas fa-user-shield verification-status-icon--webmail",
      disposable:
        "fas fa-shield-exclamation verification-status-icon--disposable",
      unknown: "fas fa-shield-slash verification-status-icon--unknown",
      error: "fas fa-xmark verification-status-icon--error",
      invalid: "fas fa-shield-xmark verification-status-icon--invalid",
    },
  },
  defaultVariants: {
    status: "unknown",
  },
})

const iconClasses = {
  valid: "fas fa-shield-check",
  accept_all: "fas fa-shield-halved",
  webmail: "fas fa-user-shield",
  disposable: "fas fa-shield-exclamation",
  unknown: "fas fa-shield-slash",
  error: "fas fa-xmark",
  invalid: "fas fa-shield-xmark",
}

export const VerificationStatus = ({
  email,
  date,
  status,
  revealed,
}: {
  email: string
  date: Date | null
  status?: VariantProps<typeof iconVariants>["status"]
  revealed: boolean
}) => {
  const { isVerifying, verifyEmail } = useVerifyEmail(email)

  let localStatus = status || "unknown"
  const verifyOperationCost = CostCalculator.calculateVisualRepresentation(
    "verify",
    1,
  )

  return (
    <>
      <span
        className={iconVariants({ status: localStatus })}
        data-controller="tooltip"
        data-bs-placement="top"
        data-bs-toggle="tooltip"
        data-testid="verification-status-icon"
        data-bs-original-title={i18n.t(`js.verification_status.${localStatus}`)}
      />
      {revealed && status === null && (
        <Button
          size="xs"
          type="button"
          onClick={() => verifyEmail()}
          disabled={isVerifying}
        >
          Verify
          <ButtonSuffix>
            <span className="cost-indicator cost-indicator--bare">
              <Icon icon="coin" size="xs" className="cost-indicator__icon" />
              {CurrencyHelper.numberWithDelimiter(verifyOperationCost)}
            </span>
          </ButtonSuffix>
        </Button>
      )}
    </>
  )
}
